/* globals Vue, VueSlideUpDown, MediaQuery, _ */
/* exports vm */
/* esnext */

'use strict';

(function(){

    Vue.filter('join', function (value, separator = '') {
        if (!value) {
            return '';
        }
        if (!Array.isArray(value)) {
            return value;
        }
        return value.join(separator);
    });

    Vue.component('vue-slide-up-down', VueSlideUpDown);

    Vue.component('filter-field', {
        name: 'filter-field',
        props: ['filter'],
        data () {
            return {

            };
        },
        computed: {
            classNames () {
                return [
                    'filter--' + this.filter.name,
                    {
                        'is-open': this.filter.isOpen,
                        'is-active': this.isActive,
                        'is-collapsible': this.isCollapsible,
                        'has-header': this.filter.header,
                    }
                ];
            },
            optionTitles () {
                return this.filter.options.map((option) => option.title);
            },
            numOptions () {
                return this.filter.options.length;
            },
            isCollapsible () {
                return this.filter.toggle;
            },
            isOpen () {
                return !this.isCollapsible || this.filter.isOpen;
            },
            evenOrUneven () {
                return this.numOptions % 2 === 0 ? 'even': 'uneven';
            },
            checkedOptionsArray () {
                return Array.isArray(this.filter.checkedOptions) ?  this.filter.checkedOptions : [this.filter.checkedOptions];
            },
            checkedOptionsTitles () {
                return this.filter.options
                        .filter((option) => this.checkedOptionsArray.indexOf(option.id) !== -1)
                        .map((option) => option.title);
            },
            checkedOptionsSummary () {
                return this.checkedOptionsTitles.join(', ');
            },
            isActive () {
                return this.checkedOptionsArray.length > 0;
            },
        },
        watch: {
            isOpen (val) {
                if (val) {
                    bus.$emit('/filter/open', this.filter);
                }
            }
        },
        methods: {
            reset () {
                this.filter.checkedOptions = [];
                bus.$emit('/filter/change', this.filter);
            },

            handleLabelClick (event) {
                // Close filter after selecting from single-choice field
                if (!this.filter.multi) {
                    this.filter.isOpen = false;
                }
                bus.$emit('/filter/change', this.filter);
            },
        },
        template: '#filter-field'
    });

    var vm = new Vue({

        el: '#filter-app',

        data: {
            config: window.$App.config,
            texts: window.$App.texts,

            filters: window.$App.contentFilters,

            isFormVisible: false,
            hasChanged: false,
        },

        filters: {

        },

        beforeMount () {

            // Close all filters but clicked one
            bus.$on('/filter/open', (openFilter) => {
                this.closeFiltersButOne(openFilter);
            });

            // Mark inputs as changed
            bus.$on('/filter/change', () => {
                this.hasChanged = true
            });
        },

        mounted () {
            this.toggleFormVisibility(true);

            // Register events
            document.addEventListener('keyup', this.handleEscapeKey);
        },

        beforeDestroy () {
            document.removeEventListener('keyup', this.handleEscapeKey);
        },

        computed: {

            __ () {
                return this.texts;
            },

            numActiveFilters () {
                return this.filters.filter(filter => {
                    var checked = Array.isArray(filter.checkedOptions) ? filter.checkedOptions : [filter.checkedOptions];
                    return checked.length > 0;
                }).length;
            },

            hasActiveFilters () {
                return this.numActiveFilters > 0;
            },

            classNames () {
                return [
                    {
                        'is-form-visible': this.isFormVisible,
                        'has-active-filters': this.hasActiveFilters,
                        'has-changes': this.hasChanged,
                    }
                ];
            },
        },

        methods: {

            toggleForm () {
                this.isFormVisible = !this.isFormVisible;
            },

            toggleFilterField (category) {
                if (this.isCategoryActive(category)) {
                    this.activeCategory = null;
                }
                else {
                    this.activeCategory = category;
                }
            },

            isFilterFieldActive (category) {
                return this.activeCategory && this.activeCategory.id === category.id;
            },

            handleEscapeKey (event) {
                if (event.keyCode === 27) { // esc

                }
            },

            submitForm () {
                this.$refs.filterForm.submit();
            },

            handleSubmit (event) {
                // Prevent trailing '?' for empty form submissions
                // by going directly to the action URL

                if (!this.hasActiveFilters) {
                    event.preventDefault();
                    window.location = this.$refs.filterForm.action;
                }
            },

            toggleFormVisibility (immediate) {
                var $el = $(this.$refs.filterForm);
                var func = this.isFormVisible ? 'slideDown' : 'slideUp';
                if (immediate) {
                    $el[func](0);
                } else {
                    $el[func]();
                }
            },

            closeFilter (filter) {
                filter.isOpen = false;
            },

            closeFiltersButOne (filterToLeaveOpen) {
                var filtersToClose = this.filters.filter(filter => filterToLeaveOpen.name !== filter.name);
                filtersToClose.forEach(this.closeFilter);
            },

            resetFilter (filter) {
                filter.checkedOptions = [];
                if (!this.isFormVisible) {
                    setTimeout(() => this.submitForm(), 250);
                }
            },

            resetFilterForm () {
                this.filters.forEach(this.resetFilter);
            },

        },

        watch: {

            isFormVisible (val) {
                this.toggleFormVisibility();
                if (val) {
                    document.body.classList.add('is-filter-open');
                }
                else {
                    setTimeout(() => document.body.classList.remove('is-filter-open'), 500);
                }
            },

        }
    });

})();
